import Storage from "@/utils/Storage";
import { ACCEPTED, AGREED_TO_ANALYTICS_CONSENT } from "@/utils/constants";

export function analyticsAccepted(): boolean {
  return Storage.get(AGREED_TO_ANALYTICS_CONSENT) === ACCEPTED;
}
